<template>
  <div class="gallery-container">
    <div class="gallery-grid">
      <div
          v-for="(image, index) in images"
          :key="index"
          class="gallery-item-wrapper"
      >
        <el-image
            :src="image.src"
            :alt="image.alt"
            :preview-src-list="previewList"
            :initial-index="index"
            fit="inherit"
            :lazy="false"
            class="gallery-item"
            hide-on-click-modal
        >
          <template #error>
            <div class="image-error">
              <i class="el-icon-picture-outline"></i>
            </div>
          </template>
          <template #placeholder>
            <div class="image-loading">
              <i class="el-icon-loading"></i>
            </div>
          </template>
        </el-image>
        <p v-if="image.caption" class="caption">{{ image.caption }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SGallery',
  props: {
    images: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    previewList() {
      return this.images.map(img => img.src)
    }
  }
}
</script>

<style scoped>
.gallery-container {
  width: 100%;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 20px;
  padding: 20px;
}

.gallery-item-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.gallery-item {
  width: 100%;
  height: 280px; /* 增高以适配长图，等比缩放不变形 */
  border-radius: 8px;
  transition: transform 0.3s, box-shadow 0.3s;
  cursor: pointer;
  background: #ffffff;
  border: 1px solid #eef2ef;
  box-shadow: 0 6px 16px rgba(0,0,0,0.04);
}

.gallery-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 28px rgba(0,0,0,0.08);
}

.caption {
  text-align: center;
  margin: 0;
  font-size: 14px;
  color: #666;
}

.image-error,
.image-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #f5f7fa;
  color: #909399;
  font-size: 30px;
}

@media (max-width: 768px) {
  .gallery-item { height: 220px; }
}
</style>
